module.exports = __webpack_public_path__ + "img/_DSC0544 2 4.22b13691.jpg";